import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { enumValidator, PartnerOrganizationMemberRole } from '#validation';
import { createListQuery } from '#web-service-api/common';
import { PartnerOrganizationMemberResponseSchema } from '../response';
export const PartnerOrganizationMemberListQuery = createListQuery({
    schema: PartnerOrganizationMemberResponseSchema,
    sortable: {
        by: ['role', 'status', 'createdAt'],
        default: 'createdAt',
    },
    pageSize: {
        default: 10,
        max: 100,
    },
    filters: z.object({
        role: enumValidator({
            values: PartnerOrganizationMemberRole,
            invalidValueError: 'partnerOrganization.member.role.invalid',
        }).exactOptional(),
    }),
});
export class PartnerOrganizationMemberListQueryDto extends createZodDto(PartnerOrganizationMemberListQuery.codec) {
}
